const formatDate = (date) => {
    const d = new Date(Date.parse(date));
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
};

const formatDateZ = (date) => {
    const d = new Date(Date.parse(`${date}Z`));
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
};

const formatDateYMD = date => {
    const d = new Date(Date.parse(date));
    return `${d.getFullYear()}-${doubleDigit(d.getMonth() + 1)}-${doubleDigit(d.getDate())}`;
};

const formatDateUTCMidnight = date => {
    return `${formatDateYMD(date)}T00:00:00.000Z`;
};

const formatTime = date => {
    const d = new Date(Date.parse(date));
    return `${doubleDigit(d.getHours())}:${doubleDigit(d.getMinutes())}`;
};

const formatTimeZ = date => {
    const d = new Date(Date.parse(`${date}Z`));
    return `${doubleDigit(d.getHours())}:${doubleDigit(d.getMinutes())}`;
};

const formatTimeLong = date => {
    const d = new Date(Date.parse(date));
    return `${formatTime(date)}:${doubleDigit(d.getSeconds())}`;
};

const formatDateTime = date => {
    return `${formatDate(date)} ${formatTime(date)}`;
};

const formatDateTimeZ = date => {
    return `${formatDateZ(date)} ${formatTimeZ(date)}`;
};

const formatDateTimeLong = date => {
    return `${formatDateLong(date)} ${formatTimeLong(date)}`;
};

const formatDateLong = date => {
    const d = new Date(Date.parse(date));
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const dateStr = doubleDigit(d.getDate());
    return `${dateStr} ${monthNames[d.getMonth()]} ${d.getFullYear()}`;
};

const parseDate = str => {
    try {
        if (str.indexOf('+') === -1 && str.indexOf('Z') === -1) str = `${str}Z`;
        return new Date(Date.parse(str));
    } catch (e) {
        return undefined;
    }
};

const parseDateInput = str => {
    const dateParsed = str.split('/');
    if (dateParsed.length === 3) {
        const dateObject = Date.parse(`${dateParsed[2]}/${dateParsed[1]}/${dateParsed[0]}`);
        if (!isNaN(dateObject)) return formatDateUTCMidnight(new Date(dateObject));
    }
    return null;
};

const doubleDigit = number => {
    return number.toLocaleString('en-AU', { minimumIntegerDigits: 2, useGrouping: false });
};

const humanReadableInterval = milliseconds => {
    const numberEnding = number => {
        return number > 1 ? 's' : '';
    };

    let temp = Math.floor(milliseconds / 1000);
    const years = temp > 0 ? Math.floor(temp / 31536000) : Math.ceil(temp / 31536000);
    if (years) return years + ' year' + numberEnding(years);

    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) return days + ' day' + numberEnding(days);

    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) return hours + ' hour' + numberEnding(hours);

    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) return minutes + ' minute' + numberEnding(minutes);

    const seconds = temp % 60;
    if (seconds) return seconds + ' second' + numberEnding(seconds);

    return 'less than a second';
};

export { formatDate, formatDateZ, formatDateYMD, formatDateUTCMidnight, formatDateTime, formatDateTimeZ, formatDateTimeLong, formatDateLong, parseDate, parseDateInput, humanReadableInterval };
